module.exports = __webpack_public_path__ + "static/media/component-14.b94f0815.svg";